export default __webpack_public_path__ + "static/media/p2.76d342de.jpg";